<template>
  <div>
    <div class="commonFilter">
      <div class="card-container">
        <div class="card-content">
          <Form ref="pageParams" :model="pageParams" :label-width="90" label-position="right">
            <div class="platformParamsSelect">
              <Row>
                <Col span="6">
                  <Form-item :label="$t('common.merchantId') + '：'">
                    <Input v-model.trim="pageParams.merchantId"></Input>
                  </Form-item>
                </Col>
                <Col span="3" push="1">
                  <Button @click="search" type="primary" v-once icon="search">{{$t('common.search')}}</Button>
                </Col>
              </Row>
            </div>
          </Form>
        </div>
      </div>
    </div>
    <div class="orderTable normalTop">
      <Table highlight-row border :columns="waybillColumns" :height="tableHeight" :data="waybillData"></Table>
      <div class="table-page">
        <div class="table-page-right">
          <Page :total="total" @on-change="changePage" show-total :page-size="pageParams.pageSize" show-elevator :current="pageParams.pageNum"  show-sizer @on-page-size-change="changePageSize" placement="top"  :page-size-opts="pageArray"></Page>
        </div>
      </div>
    </div>
    <!-- 渠道 -->
    <Modal v-model="waybillModal" width="1000" :mask-closable="false">
      <p slot="header">
        <span>{{$t('logisticsProvider.editWaybillNum')}}</span>
      </p>
      <div>
        <Table highlight-row border :columns="waybillModalColumns" :height="waybillModalTableHeight" :data="waybillModalData"></Table>
      </div>
      <div slot="footer">
        <Button @click="closeBtn">{{$t('common.close')}}</Button>
      </div>
    </Modal>
    <!-- 文本添加 -->
    <div v-if="txtModal">
      <Modal v-model="txtModal" width="750" :mask-closable="false">
        <p slot="header">
          <span>{{$t('logisticsProvider.addtext')}}</span>
        </p>
        <Form ref="addTxtSaveData" :model="addTxtSaveData" :rules="ruleValidate">
          <Form-item prop="trackingNumber">
            <Input v-model="addTxtSaveData.trackingNumber" type="textarea" :autosize="{minRows: 5,maxRows: 7}" :placeholder="$t('logisticsProvider.textPlaceholder')"></Input>
          </Form-item>
        </Form>
        <div slot="footer">
          <Button @click="addTxtCancel">{{$t('common.cancel')}}</Button>
          <Button type="primary" @click="addTxtSave('addTxtSaveData')">{{$t('common.confirm')}}</Button>
        </div>
      </Modal>
    </div>
    <!-- excel导入 -->
    <Modal v-model="excelImport" :mask-closable="false" :loading="excelImportLoading">
        <p slot="header">
          <span>{{$t('logisticsProvider.trackExcelImport')}}</span>
        </p>
        <p class="urlText">{{ $t('logisticsProvider.addTrack') + "：" }}</p>
        <div>
          <Upload
              v-if="uploadFilesUrl && headObj.hasOwnProperty('Authorization')"
              :action="uploadFilesUrl"
              ref="upload"
              name="file"
              :data="uploadParams"
              :headers="headObj"
              :format="['xlsx','xls']"
              :show-upload-list="false"
              :on-success="handleSuccess"
              :on-format-error="handleFormatError"
              :before-upload="handleUpload">
              <Button style="marginLeft:10px;marginTop:10px;">{{ $t('logisticsProvider.addFile') }}</Button>
            </Upload>
            <div v-if="file !== null" style="marginTop:10px"> {{ $t('logisticsProvider.uploadFile') + "：" }}{{ file.name }}</div>
        </div>
        <div class="trackModalBtn">
          <!-- <a href="@static/templet/waybillTemp.xlsx">{{ $t('logisticsProvider.downLoadMoban') }}</a> -->
          <Button type="text" @click="loadTemplate">{{ $t('logisticsProvider.downLoadMoban') }}</Button>
        </div>
        <div slot="footer">
          <Button @click="importCancel">{{$t('common.cancel')}}</Button>
          <Button type="primary" @click="upload" :loading="loading3">{{$t('common.confirm')}}</Button>
        </div>
    </Modal>
  </div>
</template>
<script>
import api from '@/api/api';
import Mixin from '@/components/mixin/common_mixin';
import tableMixin from '@/components/mixin/table_mixin';
export default {
  mixins: [ Mixin, tableMixin ],
  data () {
    let self = this;
    return {
      loading3: false,
      newId: '', // 保存商户ID
      uploadFilesUrl: api.import_tracking, // 上传文件
      waybillModal: false,
      pageParamsStatus: false, // 是否重新加载货品列表数据
      pageParams: {
        merchantId: '', // 商户编号
        partnerId: '', // 合作伙伴编号
        customerId: '', // 客户ID
        startTime: '',
        endTime: '',
        pageNum: 1,
        pageSize: 10,
        startPos: 0
      },
      total: 0, // 总记录数
      waybillColumns: [
        {
          title: self.t('common.serialNum'),
          type: 'index',
          width: 70,
          fixed: 'left',
          align: 'center'
        },
        {
          title: self.t('common.merchantId'),
          key: 'merchantId',
          align: 'center'
        },
        {
          title: self.t('logisticsProvider.trackNum'),
          key: 'usedTrackingNumber',
          align: 'center'
        },
        {
          title: self.t('logisticsProvider.noTrackNum'),
          key: 'unusedTrackingNumber',
          align: 'center'
        },
        {
          title: self.t('common.status'),
          key: 'status',
          align: 'center',
          render (h, params) {
            return params.row.status === 1
              ? h('span', {
                style: {
                  color: '#3cb034'
                }
              }, self.t('common.status1'))
              : h('span', {
                style: {
                  color: '#de2910'
                }
              }, self.t('common.status0'));
          }
        },
        {
          title: self.t('common.operation'),
          key: 'edit',
          width: 140,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    self.waybillModal = true;
                    self.show(params.row.merchantId);
                    self.newId = params.row.merchantId; // 保存商户ID
                  }
                }
              }, self.t('common.edit'))
            ]);
          }
        }
      ],
      waybillData: [], // 运单号管理列表数据
      waybillModalColumns: [
        {
          title: self.t('logisticsProvider.channelName'),
          key: 'shippingMethodName',
          align: 'center'
        },
        {
          title: self.t('logisticsProvider.channelNum'),
          key: 'shippingMethodCode',
          align: 'center'
        },
        {
          title: self.t('logisticsProvider.noTrackNum'),
          key: 'unusedTrackingNumber',
          align: 'center'
        },
        {
          title: self.t('logisticsProvider.useAll'),
          key: 'usedTrackingNumber',
          align: 'center'
        },
        {
          title: self.t('common.edit'),
          width: 180,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  size: 'small'
                },
                on: {
                  click: () => {
                    self.txtModal = true;
                    self.addTxtSaveData.merchantId = params.row.merchantId;
                    self.addTxtSaveData.shippingMethodId = params.row.shippingMethodId;
                  }
                }
              }, self.t('logisticsProvider.addtext')),
              h('Button', {
                props: {
                  size: 'small'
                },
                style: {
                  marginLeft: '5px'
                },
                on: {
                  click: () => {
                    self.excelImport = true;
                    self.uploadParams.merchantId = params.row.merchantId;
                    self.uploadParams.shippingMethodId = params.row.shippingMethodId;
                    console.log(params.row);
                  }
                }
              }, self.t('logisticsProvider.excelImport'))
            ]);
          }
        }
      ],
      waybillModalData: [], // 客户渠道列表数据
      txtModal: false, // 文本添加模态
      addTxtSaveData: {
        createdBy: '', // 创建人
        createdDate: '', // 创建时间
        merchantId: '', // 商户ID
        shippingMethodId: '', // 邮寄方式ID
        status: '1', // 运单号状态（1未使用，2使用中，3已使用，4作废）
        trackingNumber: '', // 跟踪号码
        trackingNumberId: '', // 运单号码ID
        updatedBy: '', // 修改人
        updatedDate: '' // 修改时间
      },
      // 校验
      ruleValidate: {
        trackingNumber: [
          { validator: this.validateTrackNum(), trigger: 'blur' } // 跟踪号码校验
        ]
      },
      excelImport: false, // 导入跟踪号模态框显示隐藏
      confirmUpload: false, // 是否确认上传文件
      excelImportLoading: true,
      // filenode根路径
      headObj: {
        'Authorization': sessionStorage.getItem('token')
      },
      file: null,
      uploadParams: {
        merchantId: null,
        shippingMethodId: null
      }
    };
  },
  methods: {
    // 正则表达式验证数组是否有重复元素，有重复返回true；否则返回false
    validisRepeat (val) {
      // Using a Set to check for duplicates instead of regex with control characters
      const seen = new Set();
      for (const item of val) {
        if (seen.has(item)) {
          return true;
        }
        seen.add(item);
      }
      return false;
    },
    // 跟踪号码校验
    validateTrackNum () {
      let v = this;
      var reg = /^,?(?:[0-9a-zA-Z]+,)*(?:[0-9a-zA-Z]+)?$/;
      var validateTrackNum = function (rule, value, callback) {
        let n = value.split(',');
        console.log(n);
        if (!reg.test(value) && value !== '') {
          callback(new Error(v.t('validValue.trackingNumberError')));
        } else if (value === '' || value === null) {
          callback(new Error(v.t('validValue.noEnterTrackingNumber')));
        } else if (v.validisRepeat(n) === true && value !== '') {
          callback(new Error(v.t('validValue.trackingNotRepeat')));
        } else {
          callback();
        }
      };
      return validateTrackNum;
    },
    // 显示编辑运单号模态框
    show (merchantId) {
      let v = this;
      v.axios.post(api.get_trackingInfo + '?merchantId=' + merchantId)
        .then(res => {
          if (res.data.code === 0) {
            v.waybillModalData = res.data.datas;
          } else {
            v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
          }
        });
    },
    // 关闭
    closeBtn () {
      this.waybillModal = false;
    },
    // 查询
    search () {
      let v = this;
      v.pageParamsStatus = true;
      v.pageParams.pageNum = 1;
    },
    // 添加文本 保存
    addTxtSave (name) {
      let v = this;
      v.$refs[name].validate((valid) => {
        if (valid) {
          v.axios.post(api.add_trackingNumber, v.addTxtSaveData)
            .then(res => {
              if (res.data.code === 0) {
                v.txtModal = false;
                v.addTxtSaveData.trackingNumber = '';
                v.show(v.newId);
                v.pageParamsStatus = true;
                v.$Message.success(v.t('common.saveSuccess'));
              } else {
                v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
              }
            });
        } else {
          v.$Message.error(v.t('common.pleaseEnter'));
        }
      });
      // debugger;
    },
    // 取消添加文本
    addTxtCancel () {
      let v = this;
      v.txtModal = false;
      v.addTxtSaveData.trackingNumber = ''; // 取消后，输入框的值置空
    },
    // 确定导入跟踪号
    upload () {
      let v = this;
      if (v.file !== null) {
        v.loading3 = true;
        v.confirmUpload = true;
        v.$refs.upload.upload(this.file);
      } else {
        v.excelImportLoading = false;
        v.$nextTick(function () {
          v.excelImportLoading = true;
        });
        v.$Message.error(v.t('logisticsProvider.noFile'));
      }
    },
    // 取消导入跟踪号
    importCancel () {
      let v = this;
      v.file = null;
      v.excelImport = false;
    },
    // 上传成功
    handleSuccess (res, file, fileList) {
      let v = this;
      if (res.code === 0) {
        v.loading3 = false;
        v.file = null;
        v.confirmUpload = false;
        v.excelImport = false;
        v.$Message.success(v.t('common.importFileSuccess'));
        v.show(v.newId);
        v.excelImport = false;
        v.pageParamsStatus = true;
      } else {
        v.showErrorInfoFn(res.code, res.message); // 错误提示方法
        v.excelImport = true;
        v.loading3 = false;
      }
    },
    // 验证文件格式
    handleFormatError (file) {
      let v = this;
      v.$Notice.warning({
        title: v.t('error.fileFormatError'),
        desc: file.name + v.t('validValue.fileError') + ',' + v.t('common.pleaseSelect') + 'xlsx or xls'
      });
      v.excelImportLoading = false;
      v.loading3 = false;
      v.$nextTick(function () {
        v.excelImportLoading = true;
        v.confirmUpload = false;
      });
    },
    // Excel 导入
    handleUpload (file) {
      this.file = file;
      return this.confirmUpload;
    },
    // 下载模板
    loadTemplate () {
      window.location.href = './static/files/trackingNumTemp.xlsx';
    },
    // 查询列表数据
    getList () {
      let v = this;
      v.axios.post(api.get_trackingListPage, v.pageParams)
        .then(res => {
          if (res.data.code === 0) {
            v.waybillData = res.data.datas.list;
            v.total = res.data.datas.total;
          } else {
            v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
          }
        });
    }
  },
  created () {
    let v = this;
    v.tableHeight = v.getTableHeight(452);
    v.waybillModalTableHeight = v.getTableHeight(420);
    v.getList();
  },
  watch: {
    pageParamsStatus (n, o) { // 监听重置列表数据
      let v = this;
      if (n) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/logisticsProvider/components/logisticsProvider/waybillNumber.vue